import { render, staticRenderFns } from "./detail_wenda_sp.vue?vue&type=template&id=95a4422c&scoped=true&"
import script from "./detail_wenda_sp.vue?vue&type=script&lang=js&"
export * from "./detail_wenda_sp.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&"
import style1 from "./detail_wenda_sp.vue?vue&type=style&index=1&id=95a4422c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a4422c",
  null
  
)

export default component.exports